import { createRequest } from '@savgroup-front-common/core/src/services/request';

export const GET_FILE_STATES = createRequest('@@SAV/WORKFLOW/GET_FILE_STATES');

export const ON_FILE_STATE_CHANGED = createRequest(
  'WORKFLOW/ON_FILES_STATE_CHANGED',
);
